module.exports = __webpack_public_path__ + "img/1F3F4-E0067-E0062-E0065-E006E-E0067-E007F.368c67f0.svg";